export class LayoutPageClasses {

    static root = "ic3LayoutPage-root";

    /**
     * Style applied to the root element containing the dashboard pages.
     */
    static widgetPage = "ic3LayoutPage-widgetPage";
    /**
     * Style applied to
     */
    static widgetPageMargin = "ic3LayoutPage-widgetPageMargin";
    /**
     * Style applied to
     */
    static widgetPageGrid = "ic3LayoutPage-widgetPageGrid";
    /**
     * Style applied to
     */
    static widgetPageWidgets = "ic3LayoutPage-widgetPageWidgets";
    /**
     * Style applied to the page on hover.
     */
    static widgetPagePH = "ic3LayoutPage-widgetPagePH";

}

export declare type LayoutPageClassKey = keyof LayoutPageClasses;
